var map = {
	"./0.jpg": "5125",
	"./1.jpg": "98a8",
	"./2.jpg": "593c",
	"./3.jpg": "6800",
	"./4.jpg": "ffd7",
	"./Philanthropy/ourplacepeel.jpg": "a544",
	"./cart.jpg": "daaf",
	"./googleMap.jpg": "a15e",
	"./map.jpg": "4554",
	"./staff/Upnita.jpg": "1e02",
	"./staff/amanda.jpg": "7adc",
	"./staff/arpita.jpg": "29b8",
	"./staff/debbie.jpg": "cd7a",
	"./staff/dilnoor.jpg": "10d2",
	"./staff/jaden.jpg": "123f",
	"./staff/lisa.jpg": "b740",
	"./staff/mercedes.jpg": "cd4f",
	"./staff/minnie.jpg": "7efa",
	"./staff/nada.jpg": "5401",
	"./staff/navneet.jpg": "347b",
	"./staff/nina.jpg": "d597",
	"./staff/pallawi.jpg": "497b",
	"./staff/prince.jpg": "576f",
	"./staff/raman.jpg": "1b65",
	"./staff/rhea.jpg": "227d",
	"./staff/sandra.jpg": "3e77",
	"./staff/sangeeta.jpg": "9a9c",
	"./staff/sangeetat.jpg": "2138",
	"./staff/shawn.jpg": "1261",
	"./staff/silhouette.jpg": "efe8",
	"./staff/simran.jpg": "891e",
	"./staff/subriena.jpg": "8a6c",
	"./staff/tripti.jpg": "faf1",
	"./staff/vandana.jpg": "a3f9",
	"./staff/zalesha.jpg": "44fe",
	"./tempLogo.jpg": "b67d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";